import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { connect, useSelector } from "react-redux";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import DefaultButton from "../../components/DefaultButton";
import {
  getEffortChartArea,
  getEffortFishingDepth,
  getEffortFishingDepthUom,
  getEffortGearCode,
  getEffortNumberOfHauls,
  getEffortTowSoakTime,
  getInitialGearState,
  validateGear,
} from "../../constants/Effort";
import { Navigate, useLocation } from "react-router-dom";
import ChartArea from "../../components/ChartArea";
import NrHauls from "../../components/NrHauls";
import TowSoakTime from "../../components/TowSoakTime";
import FishingDepth from "../../components/FishingDepth";
import {
  getGearCodeValidation,
  validateEffortSet2,
} from "../../constants/effortValidations";
import { getTripTripId } from "../../constants/vtrTrip";
import { success } from "../../constants/colors";
import useScrollToTop from "../../components/CustomHooks/useScrollToTop";

function EffortPage2(props) {
  useScrollToTop();

  const { auth, vtrTrip, helpText, validation } = useSelector((state) => state);
  const location = useLocation();
  const { actions } = props;
  const { report_type } = location.state.trip;
  const [gearValidation, setGearValidation] = useState(null);
  const [values, setValues] = useState({
    gearcode: "",
    gearname: "",
    show_number_of_hauls: false,
    number_of_hauls_minimum: null,
    number_of_hauls_maximum: null,
    show_soak_time: false,
    soak_hours_minimum: null,
    soak_hours_maximum: null,
    chart_area: "",
    fishing_depth: "",
    fishing_depth_uom: "fa",
    number_of_hauls: "",
    tow_soak_time: { hours: "", minutes: "" },
    effortNr: null,
    trip_id: null,
    reportType: report_type,
  });

  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleChartAreaChange = function (event, reason) {
    if (reason) {
      //Save the new values when selected
      if (reason.hasOwnProperty("AREA_CODE")) {
        setValues({ ...values, chart_area: reason.AREA_CODE });
      }
    } else {
      //If emptied then empty the state
      setValues({ ...values, chart_area: "" });
    }
  };

  const handleGearPreferenceChange = function (event) {
    event.preventDefault();
    let newValue = event.currentTarget.dataset.newValue;
    let field = event.currentTarget.dataset.field;
    if (!newValue) {
      console.log("No new value provided");
      return;
    }
    if (!field) {
      console.error("No field provided");
      return;
    }

    let newState = {};
    newState[field] = newValue;
    setValues({ ...values, ...newState });
  };

  const handleTowSoakTimeChange = function (event) {
    const { name, value } = event.target;
    if (name === "tow_soak_time_hours") {
      setValues({
        ...values,
        tow_soak_time: {
          hours: value,
          minutes: values.tow_soak_time.minutes,
        },
      });
    }
    if (name === "tow_soak_time_minutes") {
      setValues({
        ...values,
        tow_soak_time: {
          hours: values.tow_soak_time.hours,
          minutes: value,
        },
      });
    }
  };

  const _cancel = (event, value) => {
    event.preventDefault();
    let errors = [];
    actions.setError(errors);
    if (value === "Cancel") {
      actions.setTripRedirect();
    }
  };

  const _next = (event, value) => {
    event.preventDefault();
    let allErrors = validateEffortSet2(values, validation.validations.gear);
    actions.setError(allErrors);
    if (allErrors.length > 0) {
      console.log("effortPage2", allErrors);
      return;
    }

    if (value === "Save") {
      actions.updateEffort(values, auth.client_id);
    }
  };

  useEffect(() => {
    let gearCode = getEffortGearCode(location.state);
    let currentGearState = new getInitialGearState();
    let validatedGearState = validateGear(
      validation.validations.gear,
      gearCode,
      currentGearState
    );
    currentGearState.gearcode = gearCode;
    currentGearState.chart_area = getEffortChartArea(location.state);
    currentGearState.show_number_of_hauls =
      validatedGearState.show_number_of_hauls;
    currentGearState.show_soak_time = validatedGearState.show_soak_time;
    if (validatedGearState.show_number_of_hauls === true) {
      currentGearState.number_of_hauls = getEffortNumberOfHauls(location.state);
    }
    if (validatedGearState.show_soak_time === true) {
      currentGearState.tow_soak_time = getEffortTowSoakTime(location.state);
    }
    currentGearState.fishing_depth = getEffortFishingDepth(location.state);
    currentGearState.fishing_depth_uom = getEffortFishingDepthUom(
      location.state
    );
    currentGearState.effortNr = location.state.effortNr;
    currentGearState.trip_id = getTripTripId(location.state);
    setValues({ ...values, ...currentGearState });
    actions.resetTripRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let codeValidation = getGearCodeValidation(
      values.gearcode,
      validation.validations.gear
    );
    setGearValidation(codeValidation);
  }, [validation.validations.gear, values.gearcode]);

  if (vtrTrip.redirect === true) {
    return (
      <Navigate
        replace
        to={`${process.env.PUBLIC_URL}/effort-review`}
        state={{
          trip_id: values.trip_id,
          client_id: auth.client_id,
          effortNr: values.effortNr,
        }}
      />
    );
  }

  return (
    <div className="margAll10">
      <ChartArea
        changeHandler={handleChartAreaChange}
        chartAreaOptions={validation.validations.chartArea}
        chart_area={values.chart_area}
        handleGearPreferenceChange={handleGearPreferenceChange}
        chart_preference={
          auth.vtr_preferences.area ? auth.vtr_preferences.area : []
        }
        helpText={helpText.helpText}
      />
      {values.show_number_of_hauls && (
        <NrHauls
          handleInputChange={handleInputChange}
          number_of_hauls={values.number_of_hauls}
          helpText={helpText.helpText}
          validation={gearValidation}
        />
      )}
      {values.show_soak_time && (
        <TowSoakTime
          handleInputChange={handleTowSoakTimeChange}
          tow_soak_time={values.tow_soak_time}
          helpText={helpText.helpText}
          validation={gearValidation}
        />
      )}
      <FishingDepth
        handleInputChange={handleInputChange}
        fishing_depth={values.fishing_depth}
        fishing_depth_uom={values.fishing_depth_uom}
        helpText={helpText.helpText}
      />

      <Box mt={5} width="100%" align="center" className="bottom-nav-container">
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs="auto" className="margRight20">
            <DefaultButton changeHandler={_cancel} buttonText={"Cancel"} />
          </Grid>
          <Grid item xs="auto">
            <DefaultButton
              changeHandler={_next}
              buttonText={"Save"}
              bgColor={success}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default connect(mapVtrStateToProps, mapDispatchToProps)(EffortPage2);
